module.exports = __webpack_public_path__ + "img/Pt-T600.ff77d46a.gif";